import api from './api';

export type WellnessItemType = 'item' | 'category';

export interface WellnessItem {
  id: number;
  type: WellnessItemType;
  name: string;
  data: any | null;
  diagnosis_type_ids?: number[] | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface WellnessItemCreate {
  type: WellnessItemType;
  name: string;
  data?: any | null;
  diagnosis_type_ids?: number[] | null;
}

export interface WellnessItemUpdate {
  type?: WellnessItemType;
  name?: string;
  data?: any | null;
  diagnosis_type_ids?: number[] | null;
}

export const wellnessItemService = {
  async uploadPicture(file: File): Promise<{ file_id: number; file_name: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/mobile/upload-picture', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async getPictureBlobUrl(fileId: number): Promise<string> {
    const response = await api.get(`/files/${fileId}/download`, { responseType: 'blob' });
    return window.URL.createObjectURL(new Blob([response.data]));
  },

  async getAll(tenantId?: number): Promise<WellnessItem[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/wellness-items/${params}`);
    return response.data;
  },
  async getById(id: number): Promise<WellnessItem> {
    const response = await api.get(`/wellness-items/${id}`);
    return response.data;
  },
  async create(tenantId: number, data: WellnessItemCreate): Promise<WellnessItem> {
    const response = await api.post(`/wellness-items/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  async update(id: number, data: WellnessItemUpdate): Promise<WellnessItem> {
    const response = await api.put(`/wellness-items/${id}`, data);
    return response.data;
  },
  async delete(id: number): Promise<void> {
    await api.delete(`/wellness-items/${id}`);
  },
};
